@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;
@use '../@shared/input.mixin' as *;
@use '../@shared/mixins' as *;
@use '../@shared/button.mixin' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;
	@include kol-button-styles('kol-button');

	.kol-input {
		opacity: 0;
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		cursor: pointer;

		&::-webkit-file-upload-button,
		&::file-selector-button {
			cursor: pointer;
		}

		&:disabled,
		&:disabled::-webkit-file-upload-button,
		&:disabled::file-selector-button {
			cursor: not-allowed;
			pointer-events: none;
		}
	}

	.kol-input-container {
		$root: &;

		&__container {
			display: flex;
			overflow: hidden;
			align-items: center;
		}

		&__filename {
			overflow: hidden;
			flex-grow: 1;

			white-space: nowrap;
			text-overflow: ellipsis;
		}

		&:has(> #{$root}__adornment--start):has(> #{$root}__adornment--end) {
			grid-template-columns: auto 1fr;
		}
	}
}
